import React, { ReactNode } from 'react';

export default function GoldText({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={`bg-gradient-to-br from-goldLight to-goldDark bg-clip-text text-transparent ${className}`}
    >
      {children}
    </span>
  );
}
